export type Production = "production";
export type PreProduction = "preproduction";
export type Dev = "dev";
export type QA = "qa";
export type Local = "local";
export type Environment = Production | PreProduction | Dev | QA | Local;

export const environment: Environment = ((): Environment => {
  if (/local.xfinity.com/.test(window.location.hostname)) {
    return "local";
  }
  if (
    /hs-av-flow-dev-pilot.dss-ops.xfinity.com/.test(window.location.hostname) ||
    /hs-av-flow-dev.dss-ops.xfinity.com/.test(window.location.hostname)
  ) {
    return "dev";
  }
  if (
    /hs-av-flow-qa.dss-ops.xfinity.com/.test(window.location.hostname) ||
    /hs-av-flow-qa-pilot.dss-ops.xfinity.com/.test(window.location.hostname)
  ) {
    return "qa";
  }
  if (/prodtest.www.int.xfinity.com/.test(window.location.hostname)) {
    return "preproduction";
  }
  return "production";
})();
